var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 53,
    viewBox: "0 0 40 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.567 8.401H31.508V41.162000000000006H8.567z",
    transform: "translate(0 1) scale(-1 1) rotate(-6 19.108 368.818)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M12.626 24.512L27.861 24.512M12.626 27.385L27.861 27.385M21.189 30.769L27.718 30.769M6.537 12.211L1 13.063 5.156 46.572 28.918 43.683",
    transform: "translate(0 1) scale(-1 1) rotate(-6 19.108 368.818)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.433 4.837L5.45 1.428",
    transform: "translate(0 1) scale(-1 1) rotate(-6 19.108 368.818) matrix(-1 0 0 1 8.98 .586) rotate(45 5.441 3.132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.363 3.392L0.363 0",
    transform: "translate(0 1) scale(-1 1) rotate(-6 19.108 368.818) matrix(-1 0 0 1 8.98 .586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.167 9.873L6.167 6.448",
    transform: "translate(0 1) scale(-1 1) rotate(-6 19.108 368.818) matrix(-1 0 0 1 8.98 .586) rotate(90 6.167 8.16)"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#09C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.265 0L4.265 6.513",
    transform: "translate(0 1) rotate(6 -112.813 137.608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35 3.688L5.18 6.193 3.35 8.697",
    transform: "translate(0 1) rotate(6 -112.813 137.608) rotate(90 4.265 6.193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.698L0 10.3 8.531 10.3 8.531 7.698",
    transform: "translate(0 1) rotate(6 -112.813 137.608)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.65bf2a2223bea166c989bc671c2a2940.svg";
export { ForwardRef as ReactComponent };